/* eslint-disable react/jsx-no-bind */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
//import FeaturedArtist from './FeaturedArtist.js';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';
import MetaTags from 'react-meta-tags';
import urls from '../../constants/urls.js';
import PageLoading from '../common/PageLoading';
import * as qs from 'query-string';
import * as browserCheck from '../../utils/browserCheck.js';
import ToastrService from '../../services/toastrService';
import swal from 'sweetalert';
import SweetAlertTextInput from '../common/SweetAlertTextInput';
import isEmail from 'validator/lib/isEmail';
import * as urlUtils from '../../utils/urlUtils';
import ErrorMessage from '../common/ErrorMessage';
import MaterialInput from '../common/MaterialInput';

class LoginPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.login = this.login.bind(this);
        this.externalLogin = this.externalLogin.bind(this);
         this.onChange = this.onChange.bind(this);
        this.checkForExternalLoginCallback = this.checkForExternalLoginCallback.bind(this);
        this.getExternalLogins = this.getExternalLogins.bind(this);
        this.registerExternalAccount = this.registerExternalAccount.bind(this);
        this.getNext = this.getNext.bind(this);
        const loading = this.checkForExternalLoginCallback();
        this.state = 
        { 
            email: '',
            password: '',            
            externalLogins: [],
            loading: loading
         };
         
    }

    componentWillMount() {
        if(!this.state.loading) {
            this.getExternalLogins();
        }
    }

    componentDidMount() {  
        if (!this.state.loading && browserCheck.canUseDom()) {
            window.componentHandler.upgradeDom(); 
        }    
    }

    getNext() {
        //check the querystring for a returnUrl
        if(this.props.location.search) {
            const params = qs.parse(this.props.location.search);
            if(params && params.returnUrl && !urlUtils.isExternalUrl(params.returnUrl, this.props.location)) {
                if(urlUtils.isSoundCloudRedirect(this.props.location) || urlUtils.isAccountSettingsRedirect(this.props.location)) {
                    return `${params.returnUrl}${this.props.location.hash}`;
                }
                else {
                    if(this.props.user.activeProfile) {
                        return params.returnUrl;
                    }
                    else {
                        if(params.returnUrl !== '/Profile/Create') {
                            return `/Profile/Create?returnUrl=${params.returnUrl}`;
                        }
                        else {
                            return '/Profile/Create';
                        }                        
                    }
                }
            }
        }
        else if(this.props.location.state && this.props.location.state.from && this.props.location.state.from.pathname) {
            return this.props.location.state.from.pathname;
        }
        else {
            return this.props.user && this.props.user.activeProfile ? '/Welcome' : '/Profile/Create';
        }
    }

    externalLogin(event, provider) {
        event.preventDefault();
        let login;
        if(this.state.externalLogins.length) {
            login = this.state.externalLogins.find(l => l.Name === provider);
        }
        if(login) {
            const apiUrl = urls.API_URL;
            window.location = `${login.Url}`;
        }        
    }

    getExternalLogins() {
        if(!this.state.externalLogins.length) {
            //**add the full path here with the querystring encoded? returnUrl = '/Account/Login' */
            const params = qs.parse(this.props.location.search);
            let originalReturnUrl = null;
            if(params && params.returnUrl && !urlUtils.isExternalUrl(params.returnUrl, this.props.location)) {
                originalReturnUrl = params.returnUrl;
                //add a trailing slash after the url as otherwise, Safari will strip the oauth fragment added to the url after the #
                if(originalReturnUrl[originalReturnUrl.length - 1] !== '/') {
                    originalReturnUrl = originalReturnUrl + '/';
                }
            }
            const returnUrl = `${this.props.location.pathname}${originalReturnUrl ? encodeURIComponent(`?returnUrl=${originalReturnUrl}`): ''}`;
            this.props.actions.getExternalLoginsList(returnUrl)
                .then(logins => {
                    if(!this.props.user) {
                        //we've already redirected if the user is set
                        this.setState({
                            externalLogins: logins
                        });
                    }
                })
                .catch(error => {
                });
        }
    }

    registerExternalAccount(email) {
        const toastrService = new ToastrService();
        this.props.actions.registerExternal(email)
            .then(data => {
                if(!data) {
                    toastrService.showError('Social login failed', 'Sorry, something went wrong');
                    this.getExternalLogins();
                }
            })
            .catch(err => {
                toastrService.showError('Social login failed', 'Sorry, something went wrong');
                this.getExternalLogins();
            });
    }

    login(event) {
        event.preventDefault();
        this.props.actions.login(this.state.email, this.state.password);
    }

    checkForExternalLoginCallback() {
        let loading = false;
        const toastrService = new ToastrService();
        //if (browserCheck.canUseDom()) {
        const hash = this.props.location.hash;
        const isSoundCloudRedirect = urlUtils.isSoundCloudRedirect(this.props.location);
        const isAccountSettingsRedirect = urlUtils.isAccountSettingsRedirect(this.props.location);
        let params = {};
        if(hash) {
            params = qs.parse(hash.substr(1));
        }
        if (!isSoundCloudRedirect && !isAccountSettingsRedirect) {
            let accessTokenCookie = browserCheck.canUseDom() ? document.cookie
                .split('; ')
                .find(row => row.startsWith('AccessToken')) : null;
            let accessToken = accessTokenCookie ? accessTokenCookie.split('=')[1] : (params.access_token ? params.access_token : null);
            let expiresAtCookie = browserCheck.canUseDom() ? document.cookie
                .split('; ')
                .find(row => row.startsWith('ExpiresAt')) : null;
            let expires = expiresAtCookie ? decodeURIComponent(expiresAtCookie.split('=')[1]) : (params.expires_at ? params.expires_at : null);

            if(accessToken) {
                loading = true;
                //delete the token details from the cookie now we've read it (it's set to expire in 5 mins but let's be extra safe)
                const domain = window.location.hostname;
                document.cookie = `AccessToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
                document.cookie = `Expires=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
                this.props.actions.loginSuccess(accessToken);
                this.props.actions.getUserInfo()
                    .then(userInfo => {
                        if(userInfo) {
                            if(userInfo.HasRegistered) {
                                this.props.actions.getUser(true);
                            }
                            else {
                                swal('It looks like you don\'t have an account, would you like to create one?', {
                                    buttons: [true, 'Create Account']
                                }).then(value => {
                                    if(value) {
                                        if(userInfo.Email) {
                                            this.registerExternalAccount(userInfo.Email);
                                        }
                                        else {
                                            const wrapper = document.createElement('div');
                                            ReactDOM.render(<SweetAlertTextInput type="email" label="Email address" />, wrapper);
                                            const el = wrapper.firstChild;
                                            swal('Please enter your email address', {
                                                content: el,
                                                buttons: [true, true]
                                            })
                                            .then(email => {
                                                if(email) {
                                                    if(isEmail(email)) {
                                                        this.registerExternalAccount(email);
                                                    }
                                                    else {
                                                        toastrService.showError('Social login failed', 'The email address entered doesn\'t look quite right');
                                                        this.getExternalLogins();
                                                    }
                                                }
                                                else {
                                                    toastrService.showError('Social login failed', 'We need your email address to complete the sign up');
                                                    this.getExternalLogins();
                                                }
                                            });
                                        }
                                    }
                                    else {
                                        this.getExternalLogins();
                                    }
                                });
                                    
                                this.setState({
                                    loading: false
                                });
                            }
                        }
                        else {
                            toastrService.showError('Social login failed', 'Sorry, it looks like your login attempt may have timed out, please try again');
                            this.setState({
                                loading: false
                            });
                            this.getExternalLogins();
                        }
                    })
                    .catch(error => {
                        this.setState({
                            loading: false
                        });
                    });
            }
            else if(params.error) {
                toastrService.showError('Social login failed', 'Sorry, something went wrong, unable to complete login');
            }
        } 
        else if(isSoundCloudRedirect) {
            //setting loading to true stops us showing this login page which is good here as we want to redirect
            loading = true;
        }   
        return loading;
    }

    onChange(event) {
        const field = event.target.name;
        const value = event.target.value;
        let newState = Object.assign({}, this.state);
		newState[field] = value;
		return this.setState(newState);
    }

    render() {
        return (
            this.props.user ?
                <Redirect to={this.getNext()} />
                :
                !this.state.loading && !this.props.userLoading ?
                    <div className="main">
                        <MetaTags>
                            <title>Login - LoudUp</title>
                            <meta id="description" name="description" content="Log into your LoudUp account to get connected, manage your profile, and view your notifications" />
                            <meta id="robots" name="robots" content="noindex" />
                        </MetaTags> 
                        <div className="container">
                            <div className="block-inner">
                                <div className="signupbox">
                                    <h1 className="section-alt">Log into your account</h1>
                                    <br />
                                    <div className="signbody">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <h3>LOG IN WITH YOUR SOCIAL ACCOUNT</h3>
                                                <div className="socsignup">
                                                    <div className="soclogin text-center">
                                                        <a href={null} style={{cursor: "pointer"}} onClick={(e) => this.externalLogin(e, 'Facebook')}>
                                                            <img src={require('../../images/btn-sociallog-fb.png')} width="240" height="41" alt="Log in with Facebook" />
                                                        </a>
                                                        <br />
                                                        <br />
                                                        <a href={null} style={{cursor: "pointer"}} onClick={(e) => this.externalLogin(e, 'Twitter')}>
                                                            <img src={require('../../images/btn-sociallog-tw.png')} width="240" height="41" alt="Log in with Twitter" />
                                                        </a>
                                                    </div>
                                                    <br />
                                                    <p className="grey text-center"><span className="arrow-right" />Quicker sign-up</p>
                                                    <p className="grey text-center"><span className="arrow-right" />One less password to remember!</p>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <h3>LOG IN WITH YOUR LOUDUP ACCOUNT</h3>
                                                <p className="text-center grey">
                                                    Don't have an account? <Link to="/Account/Signup">Click to sign up »</Link>
                                                </p>
                                                <br />
                                                <form id="frmLogin" onSubmit={this.login}>
                                                    <div className="form form-signup form-tightfields">
                                                        <MaterialInput name="email" label="E-mail address" type="email" value={this.state.email} onChange={this.onChange} />
                                                        <MaterialInput name="password" label="Password" type="password" value={this.state.password} onChange={this.onChange} />
                                                        <div className="form-group form-delimited">
                                                            <input id="button" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-block" type="submit" value="LOG IN" name="button" />
                                                            <br />
                                                            <p className="text-center grey text-forgotpass">
                                                                <Link to={`/Account/ForgottenPassword${this.state.email ? `?email=${this.state.email}` : ''}`}>Forgot your password? »</Link>
                                                            </p>
                                                        </div>
                                                        <ErrorMessage error={this.props.loginError} onClose={this.props.actions.clearLoginError} />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                :
                    <div>
                        <PageLoading />
                    </div>
        );
    }
}

LoginPage.propTypes = {
    user: PropTypes.object,
    loginError: PropTypes.string,
    actions: PropTypes.object.isRequired,
    location: PropTypes.object,
    userLoading: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    return { 
        user: state.account.user,
        userLoading: state.account.userLoading, 
        loginError: state.account.loginError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);